import { cn } from "@/lib/utils";
import SignalField from "@/components/SignalField";

export default function PageHero({ eyebrow, title, description, className = "", testid }) {
  return (
    <section
      data-testid={testid || "page-hero"}
      className={cn(
        "relative overflow-hidden bg-brand-dark text-brand-off",
        className,
      )}
    >
      <SignalField className="absolute inset-0 w-full h-full opacity-90" density={140} />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-dark/30 via-transparent to-brand-dark/40 pointer-events-none" />
      <div className="container-x relative z-10 pt-24 pb-20 md:pt-32 md:pb-28">
        <div className="max-w-3xl animate-fade-up">
          {eyebrow && <p className="eyebrow-light mb-5">{eyebrow}</p>}
          <h1 className="text-4xl sm:text-5xl md:text-[64px] leading-[1.05] tracking-tight font-light text-brand-off">
            {title}
          </h1>
          {description && (
            <p className="mt-6 text-white/70 text-[16.5px] leading-relaxed max-w-2xl">
              {description}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
